import { connect } from 'react-redux'
import ProductList from '../../components/ProductList/ProductList'
import executeBeacon from '../../actions/executeBeacon'
import { onBeaconSent } from '../../redux/hookLogic/hookLogic'
import { userStateSelector } from '../../selectors/application'

const mapStateToProps = state => {
  return {
    templateType: state.category.templateType,
    hookLogic: state.hookLogic,
    userState: userStateSelector(state),
    showLoader: state.application.loader.show,
    destinationPageType: state.application.destinationPageType,
    searchTerm: state.product.searchTerm,
    numberOfResults: state.product.numberOfResults,
    currentPage: state.product.currentPage,
    pageSize: state.product.pageSize
  }
}

const mapDispatchToProps = dispatch => {
  return {
    sendHookLogicImpressionBeacon: (attributes, hookLogic) => {
      if (attributes.featured && !isNaN(attributes.price)) {
        setTimeout(() => {
          executeBeacon(
            hookLogic,
            payload => {
              dispatch(onBeaconSent(payload))
            },
            { productId: attributes.partNumber },
            'impBeacon'
          )
        }, 0)
      }
    },
    sendHookLogicClickBeacon: (attributes, hookLogic, partNumber) => {
      if (attributes.featured && !isNaN(attributes.price)) {
        setTimeout(() => {
          executeBeacon(
            hookLogic,
            payload => {
              dispatch(onBeaconSent(payload))
            },
            { productId: partNumber },
            'clickBeacon'
          )
        }, 0)
      }
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductList)
